module.exports = __webpack_public_path__ + "img/FSc (Engineering).3aea16a9.svg";